import React, { useState, useEffect } from "react";
import "../../assets/css/ManageModel.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
// import { getapi, postapi } from '../API';
import { Link } from "react-router-dom";


function Customerwisedetails() {
    const [search, setSearch] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(50); const [showModal, setShowModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [brands, setBrands] = useState([])
    const [brand, setBrand] = useState([]);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;
    const [modelName, setModelName] = useState("");
    const [modelBrand, setModelBrand] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        getAdminData();
        getbrandData()
    }, [page, rowsPerPage]);


    const getAdminData = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/customerwisedetails?start=0&length=100&?type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log('managemodel', response)
            if (response.data && response.data.data) {
                setBrands(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // const handleDeleteClick = (id) => {
    //   setDeleteId(id);
    //   setShowModal(true);
    // };

    const confirmDelete = async () => {
        if (!deleteId) return;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/models/delete/${deleteId}??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Brand deleted successfully", { position: "top-right" });
                setBrands((prevBrands) => prevBrands.filter((brand) => brand.id !== deleteId));
            } else {
                toast.error("Failed to delete the brand.", { position: "top-right" });
            }
        } catch (error) {
            console.error("Error deleting brand:", error);
            toast.error("An error occurred while deleting the brand.", { position: "top-right" });
        }

        setShowModal(false);
        setDeleteId(null);
    };

    const getbrandData = async () => {

        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token

        console.log("Token: ?????", token);

        try {
            const response = await axios.get(
                'https://devapi.bykit.in/api/admin/get_users?page=1&search=&?type=live',
                {
                    method: 'post',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

            console.log("API Response:", response);

            if (response.data.status === "RC200") {
                setBrand(response.data.data);
            } else {
                alert('Invalid credentials, please try again.');
            }
        } catch (error) {
            console.error('Error during login:', error);
        }
    };

    const columns = [
        { name: "First name", selector: (row) => row.first_name || "N/A", sortable: true },
        { name: "Email", selector: (row) => row.email || "N/A", sortable: true },
        { name: "Phone", selector: (row) => row.phone || "N/A", sortable: true },
        { name: "Date", selector: (row) => row.date || "N/A", sortable: true },
        {
            name: "Has Bookings",
            selector: (row) => (row.bookings && row.bookings.length > 0 ? "Yes" : "No"),
            sortable: true
        },
    ];


    const handlePageChange = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (newRows) => {
        setRowsPerPage(newRows);
        setPage(1);
    };

    const formatDateDDMMYYYY = (inputDate) => {
        if (!inputDate) return "N/A";
        const date = new Date(inputDate);
        if (isNaN(date)) return "Invalid Date";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const formatDateDDMMYYYY_HHMM = (inputDate) => {
        if (!inputDate) return "N/A";
        const date = new Date(inputDate);
        if (isNaN(date)) return "Invalid Date";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };



    return (
        <div className="p-3">
            <ToastContainer />
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Customer Details</p>
            </div>
            <div className="managebrand_box mt-3 mb-2 py-4">
                <div className="d-flex justify-content-between mb-3">
                    <h4 className="dashboard_head ps-3">Customer Details</h4>
                </div>
                <hr />

                <div className='d-flex justify-content-between mt-3 px-3'>


                    <div className="d-flex">
                        <input
                            type="text"
                            placeholder="Search keyword"
                            className="search-input me-2"
                            style={{ padding: '8px' }}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>


                <DataTable
                    columns={[
                        { name: "First Name", selector: (row) => row.first_name || "N/A", sortable: true },
                        { name: "Email", selector: (row) => row.email || "N/A", sortable: true },
                        { name: "Phone", selector: (row) => row.phone || "N/A", sortable: true },
                        { name: "Customer Since", selector: (row) => row.date || "N/A", sortable: true },
                        {
                            name: "Bookings",
                            selector: (row) => (row.bookings && row.bookings.length > 0 ? "Yes" : "No"),
                            sortable: true,
                        },
                    ]}
                    data={brands.filter((item) =>
                        item.first_name?.toLowerCase().includes(search.toLowerCase())
                    )}
                    pagination
                    responsive
                    //paginationTotalRows={totalRows}
                    paginationPerPage={rowsPerPage}
                    paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    expandableRows
                    expandableRowDisabled={(row) => !row.bookings || row.bookings.length === 0}

                    expandableRowsComponent={({ data }) => (
                        <div style={{ padding: "10px 20px", backgroundColor: "#f9f9f9" }}>
                            {data.bookings && data.bookings.length > 0 ? (
                                data.bookings.map((booking, index) => (
                                    <div key={index} style={{ marginBottom: "10px" }}>
                                        <p><strong>Booking ID:</strong> {booking.id}</p>
                                        <p><strong>Booking Date:</strong> {formatDateDDMMYYYY(booking.created_at)}</p>
                                        <p><strong>Servicing Date:</strong> {formatDateDDMMYYYY(booking.service_date)}</p>
                                        <p><strong>Pickup Date and Time:</strong> {formatDateDDMMYYYY(booking.service_date)} {booking.expected_pickuptime}</p>
                                        <p><strong>Service Complete Time:</strong> {formatDateDDMMYYYY_HHMM(booking.service_complete_time) || "N/A"}</p>
                                        <p><strong>Address:</strong> {booking.address || "N/A"}</p>
                                        <p><strong>Workshop:</strong> {booking.workshop_name || "N/A"}</p>
                                        <p><strong>Vehicle Regn No:</strong> {booking.vehicle_name || "N/A"}</p>
                                        <p><strong>Insurance Expiry Date:</strong> {booking.insurance_expiry_date != '1970-01-01' ? formatDateDDMMYYYY(booking.insurance_expiry_date) : "Not Filled by Customer"}</p>
                                        <p><strong>Delivery Boy assigned:</strong> {booking.delivery_name || "N/A"}</p>

                                        {booking.invoice ?
                                            <div>
                                                <p><strong>Invoice: </strong>
                                                    <Link

                                                        to={'https://devapi.bykit.in/storage/brands/' + `${booking.invoice}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ marginRight: 10 }}
                                                    >
                                                        View Invoice
                                                    </Link></p></div> : null
                                        }


                                        <p><strong>Invoice Amount:</strong> {booking.invoice_amount ? `₹${booking.invoice_amount}` : "N/A"}</p>


                                        <hr />
                                    </div>
                                ))
                            ) : (
                                <p>No bookings available for this customer.</p>
                            )}
                        </div>
                    )}
                    customStyles={{
                        headRow: {
                            style: {
                                backgroundColor: "#E2E8F0",
                                color: "#475569",
                                fontWeight: "600",
                            },
                        },
                        pagination: {
                            style: {
                                borderTop: "1px solid #ddd",
                                padding: "10px",
                                backgroundColor: "#f8f9fa",
                            },
                        },
                        cells: {
                            style: {
                                padding: "10px",
                                margin: "0",
                                fontSize: "16px",
                                color: "rgb(71, 85, 105)",
                            },
                        },
                        headCells: {
                            style: {
                                margin: "0",
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "rgb(71, 85, 105)",
                            },
                        },
                    }}
                />

            </div>


            {showModal && (
                <div className="modal-overlay delete-overlay">
                    <div className="modal-content delete-content">
                        <div className="modal-header bg-dark text-white mt-0">
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className='p-3'>
                            <p className='delete_text'>Are you sure, do you want to delete?</p>
                        </div>
                        <hr className='p-0 m-0'></hr>
                        <div className="modal-buttons text-end p-3">
                            <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
                            <button onClick={confirmDelete} className='model_dlt_btn'>Yes</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default Customerwisedetails;
